import React, { useContext, useImperativeHandle } from 'react';
import { useMutation } from 'react-relay';

import { ItemFragment$data } from '../../graphql/__generated__/ItemFragment.graphql';
import UpdateListItemMutation from '../../graphql/mutations/UpdateListItemMutation';
import useCommitItem from '../../hooks/useCommitItem';
import useDispatchSetterStore from '../../hooks/useDispatchSetterStore';
import useDynamicSelector from '../../hooks/useDynamicSelector';
import { SmxPropsContext } from '../../providers/propsProvider';
import { getSetterListItem, IListItemState } from '../../store/slices/listItemSlice';
import { ListItemType } from '../../types';

const useExternalHandler = (ref: React.ForwardedRef<any>, connectionId: string) => {
    const contextProps = useContext(SmxPropsContext);
    const setterListItem = useDispatchSetterStore<IListItemState>(
        getSetterListItem(contextProps.nameList + contextProps.prefixStore),
    );
    const [commitUpdate] = useMutation(UpdateListItemMutation);
    const { getCommitItem } = useCommitItem();
    const originalItems = useDynamicSelector('listItem', 'originalItems');
    const currentItemId = useDynamicSelector('listItem', 'currentItemId');
    const currentItem = useDynamicSelector('listItem', 'currentItem');
    const typeList = useDynamicSelector('listItem', 'typeList');

    useImperativeHandle(ref, () => ({
        getCurrentItem: () => currentItem,
        // newChildId is id of child element can be negative.
        // "+" means add new one and "-" means delete exists one
        setChild: (newChildId: number) => {
            if (!currentItem) {
                return;
            }

            // todo should be rebuild with GraphQL capability (same part in useChildrenHandler
            const newOriginalItems = originalItems.map((item: ListItemType) => {
                let child = item.child;
                const listChildIds = child.split(',');
                if (newChildId > 0) {
                    child = !listChildIds.includes(`${newChildId}`) ? [...listChildIds, newChildId].join() : child;
                } else {
                    // if we use soft delete in data base we don't need delete child item
                    // child = (listChildIds.filter((idChild) => +idChild !== Math.abs(newChildId))).join();
                }

                return item.id === currentItem.id ? { ...item, child } : item;
            });

            const newCurrentItem = newOriginalItems.find((item: ListItemType) => item.id === currentItemId);

            (async () => {
                try {
                    if (typeList === 'remote') {
                        const data = {
                            child: newCurrentItem?.child,
                            name: newCurrentItem?.name,
                            type: newCurrentItem?.type,
                        } as Partial<ItemFragment$data>;

                        commitUpdate(getCommitItem(data as ItemFragment$data, connectionId, currentItemId!));
                    }

                    setterListItem({
                        currentItem: newCurrentItem,
                    });
                } catch (err) {
                    console.log(err);
                }
            })();
        },
    }));
};

export default useExternalHandler;
